var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "form-info" }, [
        _c("div", { staticClass: "form-row" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c(
              "div",
              { staticClass: "value", attrs: { title: _vm.servcOrder.no } },
              [_vm._v(_vm._s(_vm.servcOrder.no))]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-row" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c(
              "div",
              {
                staticClass: "value",
                attrs: { title: _vm.servcOrder.buyerComName }
              },
              [_vm._v(_vm._s(_vm.servcOrder.buyerComName))]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-row" }, [
          _vm._m(2),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c(
              "div",
              {
                staticClass: "value",
                attrs: { title: _vm.servcOrder.buyerShopName }
              },
              [_vm._v(_vm._s(_vm.servcOrder.buyerShopName))]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-row" }, [
          _vm._m(3),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "form-value",
              staticStyle: { width: "calc(100% - 146px)" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "value",
                  attrs: { title: _vm.servcOrder.buyerShopAddr }
                },
                [_vm._v(_vm._s(_vm.servcOrder.buyerShopAddr))]
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-row" }, [
          _vm._m(4),
          _vm._v(" "),
          _c("div", { staticClass: "form-value" }, [
            _c(
              "div",
              {
                staticClass: "value",
                attrs: { title: _vm.servcOrder.buyerShopContactTel }
              },
              [_vm._v(_vm._s(_vm.servcOrder.buyerShopContactTel))]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "el-form",
        { staticClass: "demo-ruleForm", attrs: { model: _vm.servcOrder } },
        [
          _c("div", { staticClass: "form-single" }, [
            _c("div", { staticClass: "title required" }, [
              _vm._v("请选择指派方")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "servicerComName" } },
                  [
                    _c("swb-org-tree", {
                      ref: "swb_org_tree",
                      attrs: {
                        isShowIcon: false,
                        enableSearch: true,
                        isRadio: true,
                        closed: false
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("服务订单号：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("零售商名称：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("零售商机构名称：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("机构地址：")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("电话：")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a0693ea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a0693ea","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/servcOrder/ServcOrderAppointStore.vue
// module id = 1958
// module chunks = 1